module.exports = __webpack_public_path__ + "assets/img/yi_index_lpj_on.a0548fec.png";